import { searchMembersQuery } from "@/api/member";
import { useDebouncedQuery } from "@/api/utils";
import { Command, List } from "@givenwell/command-palette";
import { UsersIcon } from "@givenwell/core-solid-icons";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

export const searchMembersCommand: Command = {
  id: "search-members",
  title: "Search Members",
  icon: <UsersIcon width="21" />,
  Component: ({ fallbackText }) => {
    const [searchText, setSearchText] = useState(fallbackText || "");
    const { data, isFetching } = useDebouncedQuery(searchMembersQuery(searchText), 150);
    const navigate = useNavigate();
    return (
      <List
        navigationTitle="Search Members"
        searchText={searchText}
        onSearchTextChange={setSearchText}
        searchBarPlaceholder="Search for members..."
        isLoading={isFetching}
        content={
          data?.members.map(member => ({
            title: `${member.given_name} ${member.family_name}`,
            actions: [
              {
                title: `View ${member.given_name} ${member.family_name}`,
                onAction: ({ close }) => {
                  navigate({
                    to: "/admin/members/$memberId",
                    params: { memberId: member.member_id },
                  });
                  close();
                },
              },
            ],
          })) || []
        }
      />
    );
  },
};
